import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth, GoogleAuthProvider, User } from "firebase/auth";
import { connectFirestoreEmulator, doc, getDoc, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();


export const isUsingEmulators =
  process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

// Override in .env.development.local when the default ports are taken
export const emulatorPort = (name: string, fallback: number) =>
  Number(process.env[`REACT_APP_EMULATOR_${name}_PORT`]) || fallback;

if (isUsingEmulators) {
  connectFirestoreEmulator(db, 'localhost', emulatorPort('FIRESTORE', 8080));
  connectAuthEmulator(auth, `http://localhost:${emulatorPort('AUTH', 9099)}`, { disableWarnings: true });
  connectFunctionsEmulator(functions, 'localhost', emulatorPort('FUNCTIONS', 5001));
  console.log('Using Firebase emulators');
}

export const checkUserAdmin = async (user: User): Promise<boolean> => {
  if (!user) return false;
  try {
    const adminRef = doc(db, "admins", user.uid);
    const adminSnap = await getDoc(adminRef);
    const isAdmin = adminSnap.exists();
    return isAdmin;
  } catch (error) {
    console.error("Error checking admin status:", error);
    return false;
  }
};
